module.exports = __webpack_public_path__ + "img/biography.7ceed670.svg";